import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { postHotelRental } from "../actions/rentals";

// ---- Room arrays and conversion map ----
export const allRooms = [
  // Floor 1
  101, 102, 103, 104, 105, 106, 109, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120,
  121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
  138, 140, 142, 144,
  // Floor 2
  201, 202, 203, 204, 205, 206, 209, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220,
  221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237,
  238, 240, 242, 244,
  // Floor 3
  301, 302, 303, 304, 305, 306, 309, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320,
  321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337,
  338, 340, 342, 344,
  // Floor 4
  400, 401, 402, 403, 404, 407, 409, 410, 411, 412, 413, 414, 415, 416, 418, 420, 422,
  423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435,
];

// Conversion map: { roomNumber: index }
export const roomIndexMap = {};
allRooms.forEach((room, i) => {
  roomIndexMap[room] = i + 1; // 1-based index
});

export const indexRoomMap = {};
allRooms.forEach((room, i) => {
  indexRoomMap[i + 1] = room; // reverse: index → room
});

// -----------------------------------------

class MontartoRentalProcessView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // selection
      lockers: [],
      // customer info
      name: '',
      phone: '',
      email: '',
      externalInvoice: '',
      // dates
      startDate: '',
      endDate: '',
      // ui
      loading: false,
      isCompact: false,
      showCustomer: false,
      expandedFloors: { 0: false, 1: false, 2: false },
      gridCols: { 2: 10, 1: 10, 0: 10 },
      roomInput: '',
      lockersError: null,
      showRooms: false,
      // petition
      successRental: null,
      lockerPasswords: [],
      errorMsg: null,
    }

    // this.floorRefs = {
    //   2: React.createRef(),
    //   1: React.createRef(),
    //   0: React.createRef(),
    // };

    // this._observers = [];
    // this._observed = {};
  }

  componentDidMount() {
    const isCompact = typeof window !== 'undefined' && window.innerWidth < 1400
    this.setState({ isCompact })
    if (typeof window !== 'undefined') {
      this._resize = () => this.setState({ isCompact: window.innerWidth < 1400 })
      window.addEventListener('resize', this._resize)
    }

    //this.setupResizeObservers();
  }

  componentWillUnmount() {
    if (this._resize) { window.removeEventListener('resize', this._resize) }
    //this._observers.forEach(o => o.disconnect());
    //this._observers = [];
  }

  // ---------- helpers ----------
  toggleLocker = (num) => {
    this.setState((prev) => ({
      lockers: prev.lockers.includes(num)
        ? prev.lockers.filter((l) => l !== num)
        : [...prev.lockers, num].sort((a, b) => a - b),
    }))
  }

  nights = () => {
    const { startDate, endDate } = this.state
    if (!startDate || !endDate) return 0
    const s = new Date(startDate)
    const e = new Date(endDate)
    const diff = Math.ceil((e - s) / (1000 * 60 * 60 * 24))
    return diff > 0 ? diff : 0
  }

  emailValid = () => {
    const { email } = this.state
    if (!email) return false
    const at = email.indexOf('@')
    const dot = email.lastIndexOf('.')
    return at > 0 && dot > at + 1 && dot < email.length - 1
  }

  phoneValid = () => {
    const { phone } = this.state
    if (!phone) return false
    const digits = phone.split('').filter(ch => ch >= '0' && ch <= '9').length
    return digits >= 7
  }

  nameValid = () => this.state.name.trim().length > 1
  lockersValid = () => this.state.lockers.length > 0 && !this.state.lockersError
  invoiceValid = () => this.state.externalInvoice.trim().length > 0
  datesValid = () => {
    const { startDate, endDate } = this.state
    return !!startDate && !!endDate && new Date(endDate) > new Date(startDate)
  }

  formValid = () => (
    this.nameValid() &&
    this.phoneValid() &&
    this.emailValid() &&
    this.lockersValid() &&
    this.datesValid()
  )

  handleSubmit = async () => {
    if (!this.formValid() || this.state.loading) return;

    const { lockers, name, phone, email, externalInvoice, startDate, endDate } = this.state;
    
    // Set start date time to 14:00
    const startDateTime = new Date(startDate);
    startDateTime.setHours(14, 0, 0, 0);
    
    const payload = {
      Lockers: lockers.map(r => String(roomIndexMap[r])), // send matricula strings
      RentalStartDate: startDateTime.toISOString(),
      RentalFinishDate: endDate,
      CustomerName: name.trim(),
      CustomerEmail: email.trim(),
      CustomerPhone: phone.trim(),
      ExternalInvoice: externalInvoice.trim(),
    };

    try {
      this.setState({ loading: true });
      const res = await this.props.postHotelRental(payload);

      console.log('API response:', res);

      if (res.error) {
        const msg = res.error.message || '';
        // Locker conflict error (API returns 409 or message includes 'already assigned for overlapping dates')
        if (
          (res.error.conflicts && Array.isArray(res.error.conflicts)) ||
          msg.includes('already assigned for overlapping dates') ||
          res.error.status === 409
        ) {
          this.setState({
            errorMsg: 'Ya existe una reserva activa para alguna de las habitaciones seleccionadas en las fechas elegidas. Por favor, cancela primero la otra reserva en curso.',
          });
        } else if (msg.includes('Locker not found')) {
          this.setState({ errorMsg: 'La habitación seleccionada no existe.' });
        } else if (msg.includes('Rental already exists')) {
          this.setState({ errorMsg: 'Ya hay una reserva en curso.' });
        } else {
          this.setState({ errorMsg: 'Error inesperado: ' + msg });
        }
      } else {
        this.setState({
          successRental: res.response.rental,
          lockerPasswords: res.response.lockerPasswords,
        });
      }
    } catch (error) {
      this.setState({
        errorMsg: error.message || null,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  parseRoomsString = (value) => {
    const nums = new Set();
    const errors = [];

    const tokens = value
      .split(',')
      .map(t => t.trim())
      .filter(Boolean);

    const pushRange = (a, b) => {
      const start = Math.min(a, b);
      const end = Math.max(a, b);
      for (let n = start; n <= end; n++) {
        if (roomIndexMap[n]) nums.add(n);
        else errors.push(`Habitación no disponible: "${n}"`);
      }
    };

    for (const token of tokens) {
      const range = token.match(/^(\d+)\s*-\s*(\d+)$/);
      if (range) {
        const a = parseInt(range[1], 10);
        const b = parseInt(range[2], 10);
        pushRange(a, b);
        continue;
      }

      const single = token.match(/^\d+$/);
      if (single) {
        const n = parseInt(token, 10);
        if (!roomIndexMap[n]) {
          errors.push(`Habitación no disponible: "${token}"`);
        } else {
          nums.add(n);
        }
        continue;
      }

      errors.push(`Formato inválido: "${token}"`);
    }

    return {
      parsed: Array.from(nums).sort((a, b) => a - b),
      error: errors.length ? errors.join(' · ') : null,
    };
  };

  addRoomsFromInput = () => {
    const { roomInput } = this.state;
    if (!roomInput.trim()) return;

    const { parsed, error } = this.parseRoomsString(roomInput);
    if (error) {
      this.setState({ lockersError: error });
      return;
    }

    this.setState(prev => {
      const merged = Array.from(new Set([...prev.lockers, ...parsed])).sort((a, b) => a - b);
      return {
        lockers: merged,
        roomInput: '',
        lockersError: null,
      };
    });
  };

  removeLocker = (n) => {
    this.setState(prev => ({
      lockers: prev.lockers.filter(x => x !== n)
    }));
  };

  printTicket = (matricula, password) => {
    const { successRental } = this.state;
    const room = indexRoomMap[Number(matricula)];
    const ticketHtml = `
    <html>
      <head>
        <title>Ticket Habitación ${room}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          h2 { margin-bottom: 10px; }
          .field { margin-bottom: 6px; }
          strong { display: inline-block; width: 140px; }
        </style>
      </head>
      <body>
        <h2>Hotel Montarto - Reserva ${successRental.Code}</h2>
        <div class="field"><strong>Habitación:</strong> ${room}</div>
        <div class="field"><strong>Pin:</strong> ${password}</div>
        <div class="field"><strong>Nombre:</strong> ${successRental.Name}</div>
        <div class="field"><strong>Email:</strong> ${successRental.Email}</div>
        <div class="field"><strong>Teléfono:</strong> ${successRental.Phone}</div>
        <div class="field"><strong>Inicio:</strong> ${new Date(successRental.StartDate).toLocaleDateString()}</div>
        <div class="field"><strong>Fin:</strong> ${new Date(successRental.FinishDate).toLocaleDateString()}</div>
        <script>window.print();</script>
      </body>
    </html>
  `;

    const newWin = window.open('', '_blank');
    newWin.document.write(ticketHtml);
    newWin.document.close();
  };

  renderRoomInput = () => {
    const { roomInput, lockersError, lockers, showRooms } = this.state;

    const onKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.addRoomsFromInput();
      }
    };

    const liveCheck = (v) => {
      if (!v.trim()) {
        this.setState({ roomInput: v, lockersError: null });
        return;
      }
      const { error } = this.parseRoomsString(v);
      this.setState({ roomInput: v, lockersError: error });
    };

    return (
      <div>
        <label className="form-label">Añadir habitaciones</label>
        <div className="input-group">
          <input
            type="text"
            className={`form-control ${lockersError ? 'is-invalid' : ''}`}
            placeholder="Ej.: 101, 201, 305"
            value={roomInput}
            onChange={(e) => liveCheck(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={this.addRoomsFromInput}
            disabled={!!lockersError || !roomInput.trim()}
          >
            Añadir
          </button>
        </div>

        {lockersError && (
          <div className="invalid-feedback d-block">{lockersError}</div>
        )}

        {/* Lista de seleccionadas */}
        <div className="mt-3">
          <div className="fw-semibold mb-1">Seleccionadas</div>
          {lockers.length === 0 ? (
            <small className="text-danger d-block">Selecciona al menos una habitación.</small>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {lockers.map(n => (
                <div key={n} className="w-100 d-inline-flex align-items-center border rounded-pill px-2 py-1">
                  <span className="me-2 w-100">Habitación {n}</span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => this.removeLocker(n)}
                  >
                    Quitar
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <button
          type="button"
          className="btn btn-outline-secondary mt-3"
          onClick={() => this.setState({ showRooms: !showRooms })}
        >
          {showRooms ? 'Ocultar habitaciones registradas' : 'Mostrar habitaciones registradas'}
        </button>

        {showRooms && (
          <div className="mt-2">
            {[1, 2, 3, 4].map(floor => (
              <div key={floor} className="mb-2">
                <strong>Planta {floor}</strong>
                <div>{allRooms.filter(r => Math.floor(r / 100) === floor).join(', ')}</div>
              </div>
            ))}
          </div>
        )}

      </div>
    );
  };

  renderLockersColumn = () => (
    <section className="p-3 border rounded-3 bg-white">
      <h4 className="mb-3">Selecciona la habitación</h4>
      {this.renderRoomInput()}
    </section>
  )

  renderCustomerColumn = () => {
    const { name, phone, email, externalInvoice, startDate, endDate } = this.state
    
    // Calculate minimum allowed date
    const now = new Date()
    const currentHour = now.getHours()
    let minDate = new Date()
    
    // If current time is after 22:00 (10 PM), minimum date is tomorrow
    if (currentHour >= 22) {
      minDate.setDate(minDate.getDate() + 1)
    }
    
    const todayISO = minDate.toISOString().slice(0, 10)
    const nights = this.nights()

    return (
      <section className="p-3 border rounded-3 bg-white" >
        <h4 className="mb-3">Datos del titular</h4>
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Nombre y apellidos"
          value={name}
          onChange={(e) => this.setState({ name: e.target.value })}
        />
        <input
          type="tel"
          className="form-control mb-2"
          placeholder="Teléfono"
          value={phone}
          onChange={(e) => this.setState({ phone: e.target.value })}
        />
        <input
          type="email"
          className="form-control mb-2"
          placeholder="Email"
          value={email}
          onChange={(e) => this.setState({ email: e.target.value })}
        />
        <input
          type="text"
          className="form-control mb-3"
          placeholder="Número de reserva externa (opcional)"
          value={externalInvoice}
          onChange={(e) => this.setState({ externalInvoice: e.target.value })}
        />

        <h4 className="mb-2">Fechas</h4>
        {currentHour >= 22 && (
          <div className="alert alert-info mb-2">
            Después de las 22:00, las reservas inician mañana
          </div>
        )}
        <div className="row g-2 mb-2">
          <div className="col">
            <label className="form-label">Inicio</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              min={todayISO}
              onChange={(e) => {
                const v = e.target.value
                const selectedDate = new Date(v)
                const minDateObj = new Date(todayISO)
                
                // Prevent dates before minimum allowed date
                if (selectedDate < minDateObj) {
                  return
                }
                
                this.setState(({ endDate }) => ({
                  startDate: v,
                  endDate: endDate && new Date(endDate) <= new Date(v) ? '' : endDate
                }))
              }}
            />
          </div>
          <div className="col">
            <label className="form-label">Fin</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              min={startDate || todayISO}
              disabled={!startDate}
              onChange={(e) => this.setState({ endDate: e.target.value })}
            />
          </div>
        </div>
        {nights > 0 && <small className="text-muted">{nights} noche{nights !== 1 ? 's' : ''}</small>}
      </section>
    )
  }

  renderResumeColumn = () => {
    const { lockers, name, phone, email, externalInvoice, startDate, endDate, loading, isCompact, showCustomer } = this.state
    const nights = this.nights()

    return (
      <aside className="p-3 border rounded-3 bg-white" >
        <h4 className="mb-3">Resumen</h4>
        <div>
          <p><span className="text-muted">Habitaciones: </span>{lockers.length ? lockers.join(', ') : '—'}</p>
          <p><span className="text-muted">Nombre: </span>{name || '—'}</p>
          <p><span className="text-muted">Teléfono: </span>{phone || '—'}</p>
          <p><span className="text-muted">Email: </span>{email || '—'}</p>
          <p><span className="text-muted">Reserva externa: </span>{externalInvoice || '—'}</p>
          <p>
            <span className="text-muted">Fechas: </span>
            {(startDate || '—')} → {(endDate || '—')} {nights > 0 ? `(${nights} noche${nights !== 1 ? 's' : ''})` : ''}
          </p>
        </div>

        <button
          type="button"
          className={`btn btn-primary mt-2 ${!this.formValid() || loading ? 'disabled' : ''}`}
          disabled={!this.formValid() || loading}
          onClick={this.handleSubmit}
        >
          {loading ? 'Enviando Reserva…' : 'Confirmar Reserva'}
        </button>
      </aside>
    )
  }

  render() {
    const { isCompact, showCustomer, successRental, lockerPasswords, errorMsg } = this.state

    if (successRental) {
      return (
        <div className="container-fluid p-4 text-center">
          <h2 className="mb-3">Reserva confirmada</h2>
          <h4 className="text-info mb-4">Código: {successRental.Code}</h4>

          <div className='d-flex'>
            {lockerPasswords.map(lp => {
              const room = indexRoomMap[Number(lp.matricula)];
              return (
                <div key={lp.matricula} className="col card m-3">
                  <div className="card-body">
                    <h5 className="card-title">Habitación {room}</h5>
                    <p><strong>Pin:</strong> {lp.password}</p>
                    <p><strong>Cliente:</strong> {successRental.Name}</p>
                    <p><strong>Email:</strong> {successRental.Email}</p>
                    <p><strong>Teléfono:</strong> {successRental.Phone}</p>
                    <p>
                      <strong>Fechas:</strong> {new Date(successRental.StartDate).toLocaleDateString()} → {new Date(successRental.FinishDate).toLocaleDateString()}
                    </p>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => this.printTicket(lp.matricula, lp.password)}
                    >
                      Imprimir ticket
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="container-fluid p-4" style={{ maxWidth: 1920 }}>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-6 col-md-6">
            <h1>
              <span className="text-vw-dark">RESERVAS </span>
              <span className="text-vw-light">HOTEL MONTARTO</span>
            </h1>
          </div>
        </div>
        <hr className="bg-vw-light" />

        <div className="row">
          {(!isCompact || !showCustomer) && (
            <div className="col-12 col-xl-4 mb-3 mb-xl-0">
              {this.renderLockersColumn()}
            </div>
          )}
          {(!isCompact || showCustomer) && (
            <div className="col-12 col-xl-4 mb-3 mb-xl-0">
              {this.renderCustomerColumn()}
            </div>
          )}
          <div className="col-12 col-xl-4">
            {this.renderResumeColumn()}
            {errorMsg && (
              <div className="alert alert-danger mt-3">
                {errorMsg}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  postHotelRental: bindActionCreators(postHotelRental, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(MontartoRentalProcessView)
